import { GlobalEvents } from "../../globalEvents";

import GlobalEvent from "./GlobalEvent";

type MultiselectQuantity = {
  qty?: number[];
  selection_id?: number[];
};

type BundleOptionInput = {
  id: number;
  quantities: MultiselectQuantity[];
  quantity?: number;
  value: string[];
};

export type AddToCartEventPayload = {
  sku: string;
  bundle: BundleOptionInput[];
  quantity: number;
};

export type ProductLimitGlobalEvent = {
  sku: string;
  limit: number;
  quantity: number;
  quantityLimitReached: boolean;
};

export type CartActiveType = {
  active: boolean;
};

export type InfoBannerEventType = {
  active: boolean;
};

export class GlobalEventsHandler {
  private readonly events: Record<string, GlobalEvent<unknown, unknown, unknown>>;

  constructor() {
    this.events = {};
  }

  createGlobalEvent<S, T, U>(name: string): GlobalEvent<S, T, U> {
    if (!this.events[name]) {
      this.events[name] = this.getNewEvent<S, T, U>(name);
    }

    return this.events[name] as GlobalEvent<S, T, U>;
  }

  // Event when cart is loaded
  getCartLoadEvent(): GlobalEvent<undefined, undefined, undefined> {
    return this.createGlobalEvent<undefined, undefined, undefined>(GlobalEvents.CartIdLoaded);
  }

  getCartActive(): GlobalEvent<CartActiveType, CartActiveType, CartActiveType> {
    return this.createGlobalEvent<{ active: boolean }, { active: boolean }, { active: boolean }>(
      GlobalEvents.CartIsActive
    );
  }

  // Event when limit is reached by product
  getProductLimitEvent(): GlobalEvent<ProductLimitGlobalEvent, undefined, undefined> {
    return this.createGlobalEvent<ProductLimitGlobalEvent, undefined, undefined>(GlobalEvents.ProductLimitReached);
  }

  // Even when global InfoBanner close event
  getInfoBanerActiveEvent(): GlobalEvent<InfoBannerEventType, InfoBannerEventType, InfoBannerEventType> {
    return this.createGlobalEvent<InfoBannerEventType, InfoBannerEventType, InfoBannerEventType>(
      GlobalEvents.InfoBannerStateChange
    );
  }

  updateLoyaltyPoints(): GlobalEvent<number, undefined, undefined> {
    return this.createGlobalEvent<number, undefined, undefined>(GlobalEvents.UpdateLoyaltyPoints);
  }

  /**
   * S : registration type
   * T : success response type
   * U : failure response type
   * @param name of event
   * @private
   */
  private getNewEvent<S, T, U>(name: string) {
    return new GlobalEvent<S, T, U>(name);
  }
}

export const globalEventsHandler = new GlobalEventsHandler();
